<template>
  <section style="margin: 0px !important">
    <div id="backBox"></div>
    <Navbar />
    <div
      class="previewContainer"
      @click="cancelPreview($event)"
      v-if="searchingGroup"
    >
      <GroupPreview :groupInfo="groupPreview" />
    </div>

    <!-- 2 columns for main page -->
    <div class="fullScreenLoadContainer" v-if="categoryGroups.length === 0">
      <div class="loader"></div>
    </div>
    <div class="mainDiscover" v-else>
      <div class="backButton" @click="goBack">
        <img src="@/assets/backArrow.svg" width="50" height="50" />
      </div>
      <div class="bannerImageContainer">
        <img class="bannerImage" :src="bannerImage" />
        <p class="bannerTitle">{{ this.category }}</p>
      </div>
      <div class="listBox">
        <div
          class="eachGroup"
          style="margin: 5.5px"
          v-for="(category, index) in categoryGroups"
          :key="index"
        >
          <div class="topGroupRow">
            <div class="groupImage">
              <img class="cover" :src="category.groupImage" />
            </div>

            <div class="textInfo">
              <p class="groupTitle">{{ category.groupTitle }}</p>
              <p class="memberNum" v-if="category.groupUserCount >= 25">
                {{ category.groupUserCount }} members
              </p>
              <p class="memberNum" v-else>New Group</p>
            </div>
          </div>
          <div class="bottomGroupRow">
            <div
              class="viewGroupButton"
              @click="
                searchCourse(
                  category.groupDoc,
                  category.groupID,
                  category.groupType
                )
              "
            >
              <p>View Group</p>
            </div>
            <!--p class="description">{{ group.groupDescription }}</p-->
          </div>
        </div>
      </div>
      <!-- FIRST COLUMN -->
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
import Navbar from "@/components/Navbar";
import GroupPreview from "@/components/group/GroupPreview.vue";
import db from "@/db";

export default {
  props: ["category"],

  data: () => ({
    folders: [],
    bannerImage: "",
    allGroups: [],
    categoryGroups: [],
  }),

  components: {
    Navbar,
    GroupPreview,
  },

  mounted() {
    if (this.category !== "Suggested for you") {
      this.fetchCategory();
    } else {
      this.fetchSuggested();
    }
  },

  computed: {
    ...mapState("messageBoard", ["groupId", "groupName", "searchingGroup"]),
    ...mapState("upload", ["isAddingFolder", "isShowingDetails", "game"]),
    ...mapState("user", ["user"]),
  },
  methods: {
    cancelPreview(event) {
      if (event.target.className == "previewContainer") {
        this.$store.commit("messageBoard/setSearchGroup", false);
        this.$store.commit("messageBoard/setCreateGroup", false);
        this.$store.commit("profile/setInterests", []);
      }
    },
    searchCourse(course, id, type) {
      course.id = id;
      course.type = type;
      this.$store.commit("messageBoard/setSearchGroup", true);
      this.$store.commit("messageBoard/setGroupPreview", course);
    },
    goBack() {
      this.$router.push({ name: "Discover" });
    },
    fetchCategory() {
      var allGroups = [];
      db.collection("categories")
        .where("name", "==", this.category)
        .get()
        .then((categories) => {
          categories.forEach(async (category) => {
            this.bannerImage = category.data().bannerImage;
            var interests = category.data().interests;
            var totalInterests = interests;
            while (interests.length) {
              totalInterests = interests.splice(0, 10);
              await db
                .collection("groups")
                .where("interests", "array-contains-any", totalInterests)
                .where("school_id", "==", this.user.school_id)
                .get()
                .then((docs) => {
                  docs.forEach((doc) => {
                    if (
                      allGroups.findIndex((x) => x.groupID === doc.id) === -1
                    ) {
                      allGroups.push({
                        groupTitle: doc.data().name,
                        groupImage: doc.data().profileImage,
                        groupDescription: doc.data().description,
                        groupUserCount: doc.data().userCount
                          ? doc.data().userCount
                          : 0,
                        groupDoc: doc.data(),
                        interests: doc.data().interests,
                        groupType: "groups",
                        groupID: doc.id,
                      });
                    }
                  });
                });
              await db
                .collection("groups")
                .where("interests", "array-contains-any", totalInterests)
                .where("isGlobal", "==", true)
                .get()
                .then((docs) => {
                  docs.forEach((doc) => {
                    if (
                      allGroups.findIndex((x) => x.groupID === doc.id) === -1
                    ) {
                      allGroups.push({
                        groupTitle: doc.data().name,
                        groupImage: doc.data().profileImage,
                        groupDescription: doc.data().description,
                        groupUserCount: doc.data().userCount
                          ? doc.data().userCount
                          : 0,
                        groupDoc: doc.data(),
                        groupType: "groups",
                        groupID: doc.id,
                      });
                    }
                  });
                });
            }
            this.categoryGroups = allGroups;
          });
        });
    },
    async fetchSuggested() {
      this.bannerImage =
        "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/discoverImages%2FsuggestedBackground.jpg?alt=media&token=ddbdc9c4-69ad-499e-9be3-2cbbf23d39ba&fbclid=IwAR3Qt1mhKT7gFlZiAETV0lxu7vk7ZmIV0C_cid9R3v0dG5L3RyuPwK96icE";
      var allGroups = [];
      await db
        .collection("groups")
        .where("interests", "array-contains-any", this.user.interests)
        .where("school_id", "==", this.user.school_id)
        .get()
        .then((docs) => {
          docs.forEach((doc) => {
            if (allGroups.findIndex((x) => x.groupID === doc.id) === -1) {
              allGroups.push({
                groupTitle: doc.data().name,
                groupImage: doc.data().profileImage,
                groupDescription: doc.data().description,
                groupUserCount: doc.data().userCount ? doc.data().userCount : 0,
                groupDoc: doc.data(),
                interests: doc.data().interests,
                groupType: "groups",
                groupID: doc.id,
              });
            }
          });
        });
      await db
        .collection("groups")
        .where("interests", "array-contains-any", this.user.interests)
        .where("isGlobal", "==", true)
        .get()
        .then((docs) => {
          docs.forEach((doc) => {
            if (allGroups.findIndex((x) => x.groupID === doc.id) === -1) {
              allGroups.push({
                groupTitle: doc.data().name,
                groupImage: doc.data().profileImage,
                groupDescription: doc.data().description,
                groupUserCount: doc.data().userCount ? doc.data().userCount : 0,
                groupDoc: doc.data(),
                groupType: "groups",
                groupID: doc.id,
              });
            }
          });
        });
      Promise.all(
        this.user.links.map((link) => {
          db.collection("users")
            .doc(link)
            .get()
            .then((userDoc) => {
              Promise.all(
                userDoc.data().groups.map((group) => {
                  if (
                    this.user.allGroups.findIndex((x) => x.id === group.id) ===
                    -1
                  ) {
                    db.collection("groups")
                      .doc(group.id)
                      .get()
                      .then((doc) => {
                        if (
                          allGroups.findIndex((x) => x.groupID === doc.id) ===
                            -1 &&
                          (doc.data().isGlobal ||
                            doc.data().school_id == this.user.school_id) &&
                          doc.data().privacyType !== "secret" &&
                          !doc.data().isGeneral
                        ) {
                          allGroups.push({
                            groupTitle: doc.data().name,
                            groupImage: doc.data().profileImage,
                            groupDescription: doc.data().description,
                            groupUserCount: doc.data().userCount
                              ? doc.data().userCount
                              : 0,
                            groupDoc: doc.data(),
                            groupType: "groups",
                            groupID: doc.id,
                          });
                        }
                      });
                  }
                })
              );
            });
        })
      );
      this.categoryGroups = allGroups;
    },
  },
};
</script>

<style src="@/styles/views/Discover.css"></style>
